import { render, staticRenderFns } from "./InsertPromotion.vue?vue&type=template&id=3bad1ade&scoped=true"
import script from "./InsertPromotion.vue?vue&type=script&lang=js"
export * from "./InsertPromotion.vue?vue&type=script&lang=js"
import style0 from "./InsertPromotion.vue?vue&type=style&index=0&id=3bad1ade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bad1ade",
  null
  
)

export default component.exports